import React from 'react'
import { motion, useScroll } from 'framer-motion'

import Lines from './parts/Lines';

export default function Contact(){
   return (
     <>
     <div id="contact" className="container contact">
     <div className="row">
       <div className="col-md-8 contact-me">
          <div className="ui-general">
             <div className="ui-text">Contact</div>
          </div>
          <h2>Get In Touch</h2>
          <p>For any questions or inquiries please send me a email and I will get back to you as soon as possible.</p>
          <div className="button-section">
            <a href="mailto:boris@bpolderman.com" role="button" className="btn"><i className="fa fa-envelope"></i> Email</a>
          </div>
        </div>
       </div>
     </div>
     <Lines></Lines>
    </>
  );
}
